import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { hashHistory } from 'react-router'
import Rowbox from '../../Common/Rowbox'
import { DECORATION_SHOP_INFO, EDIT_STORE_PATH } from '@constant'
import style from './style.module.less'
import { Rating } from 'hljd'
import { Flex } from 'hljd'
import Img from '@UI/Img'
import { dGet } from '@core/utils'
import { getMerchantInfo } from '@util'
import { SHOP_INFO_STATUS_MAP } from '@components/LocalMerchant/Decoration/constant'
import { getAddressIcon } from '@components/LocalMerchant/Decoration/util'
import { Modal } from 'hljd'

@inject('decorationStore')
@observer
export default class extends Component {
  getStatus = () => {
    const { status } = getMerchantInfo()
    return SHOP_INFO_STATUS_MAP[String(status)]
  }

  handleClick = () => {
    const { examine, is_opened_trade } = getMerchantInfo()
    // 店铺审核未通过或未交店铺服务费的不能编辑
    if (examine != 1 || !is_opened_trade) {
      return Modal.info({
        title: '店铺处于入驻审核阶段，不可编辑店铺信息'
      })
    }
    hashHistory.push(EDIT_STORE_PATH)
  }

  render() {
    const {
      decorationStore: { merchantHomeData, newThemeConfig, theme }
    } = this.props
    const { name, logo_path, v_tag, merchant_comment, group_data } = dGet(
      merchantHomeData,
      'merchant',
      {}
    )
    const { score, total_good_count } = merchant_comment || {}
    const { working_seniority, member_count } = group_data || {}

    return (
      <Rowbox
        type={DECORATION_SHOP_INFO}
        store={this.props.decorationStore}
        style={{
          height: 'auto',
          padding: '0 16px 10px',
          marginBottom: 0
        }}
        vCenter={false}
        onClick={this.handleClick}
        status={this.getStatus()}
      >
        <div
          className={style.box}
          style={{ backgroundColor: newThemeConfig['shopInfoBoxBg'] }}
        >
          <Flex
            className={style.info}
            d="v"
            vc
            style={{ borderBottom: `1px solid ${newThemeConfig['splitLine']}` }}
          >
            <Flex vc>
              <div
                className={style.name}
                style={{ color: newThemeConfig['darkestText'] }}
              >
                {name}
              </div>
              {v_tag == 1 && (
                <img src="//qnm.hunliji.com/o_1diulk139enf1fheltb15cp1jf8a.png" />
              )}
            </Flex>

            <Flex vc style={{ color: newThemeConfig['text'] }}>
              <div className={style.star}>
                <Rating
                  value={Number(score)}
                  defaultStar={newThemeConfig['defaultStar']}
                  coverStar={newThemeConfig['coverStar']}
                  size={11}
                />
              </div>
              <div className={style.num}>好评数{total_good_count}</div>
              <div className={style.num}>成员{member_count}</div>
              <div className={style.num}>平均从业{working_seniority}年</div>
            </Flex>
          </Flex>

          <Flex
            vc
            className={style.address}
            style={{ color: newThemeConfig['text'] }}
          >
            <Flex style={{ flex: 1, flexShrink: 0 }}>
              {getMerchantInfo().address}
            </Flex>
            <Flex style={{ width: 84 }} hc>
              <span>
                <img
                  src={getAddressIcon(theme)}
                  style={{ width: 14, height: 14, marginRight: 5 }}
                />
                <span>导航</span>
              </span>
            </Flex>
          </Flex>

          <Img
            src={logo_path}
            style={{ width: 100, height: 100 }}
            className={style.logo}
          />
        </div>
      </Rowbox>
    )
  }
}
